import type { PlatformFeature } from 'src/types/platform-feature';
import { RESOURCES } from 'src/utils/permissions';
import type { ResourcePath } from 'src/utils/permissions';

/**
 * The resources a feature owns. When the feature is off for the platform's edition,
 * these resources disappear from `canGet` / `canWrite` / `canDelete` — and with them
 * every nav item, route, tab, button and AI tool gated by them. `[]` = a UI-only
 * feature, hidden through `PlatformFeatureGate` / `isFeatureEnabled` instead.
 *
 * A resource belongs to at most one feature (enforced by a test), so "why is this
 * hidden" always has a single answer.
 */
export const PLATFORM_FEATURE_RESOURCES: Record<PlatformFeature, readonly ResourcePath[]> = {
  sales_history: [RESOURCES.SALES_HISTORY.MAIN],
  payment_methods: [RESOURCES.PAYMENT.MAIN],
  course_tariffs: [RESOURCES.COURSE.TARIFFS],
  public_pages: [RESOURCES.COURSE.PUBLIC_PAGE, RESOURCES.PLATFORM_SETTINGS.PUBLIC_PAGES],
  chatbot: [RESOURCES.CHATBOT.MAIN, RESOURCES.CHATBOT.COURSES, RESOURCES.CHATBOT.SETTINGS],
  corporate_learning: [
    RESOURCES.ORG_STRUCTURE.UNITS,
    RESOURCES.ORG_STRUCTURE.POSITIONS,
    RESOURCES.ASSIGNMENT.MAIN,
    RESOURCES.STUDENT.IMPORT,
    RESOURCES.ANALYTICS.TRAINING_CONTROL,
  ],
};
